import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface StaticsProps {
    courseStuCount: number;
    voteStuCount: number;
    notVoteStuCount: number;
    onClick: (params: any) => void;
}

export default function Statics({
    courseStuCount,
    notVoteStuCount,
    voteStuCount,
    onClick
}: StaticsProps) {
    return (
        <div className={style.root}>
            <div
                className={classNames(style.statics)}
                onClick={() => onClick({ status: "all" })}>
                <em>{courseStuCount}</em>课程人数
            </div>
            <div
                className={classNames(style.statics)}
                onClick={() => onClick({ status: "vote" })}>
                <em>{voteStuCount}</em>已投票
            </div>
            <div
                className={classNames(style.statics)}
                onClick={() => onClick({ status: "unVote" })}>
                <em>{notVoteStuCount}</em>未投票
            </div>
        </div>
    );
}
